import React from 'react';

import { Link } from '@ergeon/core-components';
import { DocumentTextIcon, VideoCameraIcon } from '@ergeon/icons/hero/micro';

import { getFileType, getFileNameFromUrl } from '../utils/attachmentProcessor';

// Get icon for file type
export const getFileIcon = (url: string): React.ReactNode => {
  const fileType = getFileType(url);
  if (fileType === 'video') return <VideoCameraIcon className="size-4" />;
  if (fileType === 'document') return <DocumentTextIcon className="size-4" />;
  return null;
};

// Render a single file attachment as a clickable link with icon
export const renderFileAttachment = (url: string, index: number): React.ReactNode => (
  <span className="inline-flex items-center gap-1" key={index}>
    {getFileIcon(url)}
    <Link href={url} target="_blank">
      {getFileNameFromUrl(url)}
    </Link>
  </span>
);

// Render a list of file attachments
// Can be replaced with preview components (video player, PDF viewer) in the future
export const renderFileAttachments = (urls: string[]): React.ReactNode => {
  if (urls.length === 0) return null;
  return (
    <div className="flex flex-col gap-1">
      {urls.map((url, index) => renderFileAttachment(url, index))}
    </div>
  );
};

// Wrap content with attachment links (images, videos, documents)
export const wrapContentWithAttachments = (
  content: React.ReactNode,
  imageUrls: string[],
  videoUrls: string[],
  documentUrls: string[],
): React.ReactNode => {
  if (imageUrls.length === 0 && videoUrls.length === 0 && documentUrls.length === 0) return content;

  return (
    <>
      {content}
      {renderFileAttachments(imageUrls)}
      {renderFileAttachments(videoUrls)}
      {renderFileAttachments(documentUrls)}
    </>
  );
};
